import { Breakpoint } from './types';

type BpVariants =
    | '>960'
    | '<768'
    | '>768'
    | '<959'
    | '>1140'
    | '<1140'
    | undefined;

export function bpVariant(bp?: Breakpoint): BpVariants {
    if (!bp) {
        return;
    }

    const [dir, width] = bp;
    switch (`${dir}${width}`) {
        case '>960':
            return '>960';
        case '<768':
            return '<768';
        case '>768':
            return '>768';
        case '<959':
            return '<959';
        case '>1140':
            return '>1140';
        case '<1140':
            return '<1140';
    }

    return;
}
